import {LatLng, LatLngBounds} from 'leaflet';

export const SWE_BOUNDING_BOX = new LatLngBounds(
    new LatLng(55.3617373725, 11.0273686052),
    new LatLng(69.1062472602, 23.9033785336)
);
